export const environment = {
  production: false,
  apiUrl: 'https://backend-staging-6817.up.railway.app/api',
  version: '0.1.0',
  commitHash: '9886960',
};
